import { OrderAbortTitle, OrderAbortWrap, OrderCompanyTitle, OrderHeaderRestaurant, OrderHeaderRestaurantInfo, OrderHeaderWrap, OrderPagerCode, OrderRemark, OrderSubTitle, OrderTitle } from '../index.styled'
import { getOrderTime } from '../helper'
import { getNeededDateFormat } from '../../../../../../helper'
import React from 'react'
import { useTranslation } from 'react-i18next'
import AbortedHeader from '../AbortedHeader'
import TseErstbestellung from '../TseErstbestellung'
import { getRoomChargeRoomNumber } from '../../../../../RoomCharge/helper'
import { REASON_CODE_TO_KEY } from '../constants'

const OrderHeader = React.memo(({ order }) => {
	const { t } = useTranslation()
	const roomNumber = getRoomChargeRoomNumber(order)
	const showCustomerFloor = order?.customer?.extraAddressInfo && order?.platformMetaData?.platformType === 'ONLINE_SHOP'
	const beeperCode = order?.pickupMetaData?.beeperCode || order?.kioskMetaData?.beeperCode
	const ticketOrderNumber = order?.ticketMetaData?.orderNumber
	const customerNumberText = order?.customer?.customerNumber &&
		<>{t('CompanyData.CompanyId')}: {order?.customer?.customerNumber}, </>
	const phoneNumberText = order?.customer?.phoneNumber &&
		<>Tel. {order?.customer?.phoneNumber}, </>
	const companyNameText = order?.customer?.companyName &&
		<>{order?.customer?.companyName}, </>
	const customerNameText = order?.customer?.name &&
		<>{order?.customer?.name}, </>
	const addressText = (order?.customer?.street || order?.customer?.streetNumber || order?.customer?.city || order?.customer?.postalCode) &&
		<>{order?.customer?.street} {order?.customer?.streetNumber}, {order?.customer?.city}, {order?.customer?.postalCode}</>
	const customerFloorText = showCustomerFloor &&
		<>, {order?.customer?.extraAddressInfo}</>

	const partnerDeliveryMetaData = order?.deliveryMetaData?.partner
	const orderEstimatedProcessTimestamp = order?.platformMetaData?.estimatedProcessTimestamp
	const isDeliveryByPlatform = order?.orderType === 'DELIVERY_BY_PLATFORM'
	const updatedDeliveryByPlatform = !!(order?.orderType === 'DELIVERY' && partnerDeliveryMetaData?.type && partnerDeliveryMetaData?.pickupEta)
	const isPlatformDriverOrder = isDeliveryByPlatform || updatedDeliveryByPlatform
	const driverArriveTime = isDeliveryByPlatform ?
		(orderEstimatedProcessTimestamp || order?.preOrder) :
		partnerDeliveryMetaData?.pickupEta
	const isPartnerDriverOrder = partnerDeliveryMetaData?.deliveryId
	const expectedDeliveryTime = isPlatformDriverOrder ? partnerDeliveryMetaData?.dropoffEta : orderEstimatedProcessTimestamp
	const isExpressDelivery = order?.expressDelivery
	const isAbortedOrder = order?.status?.status === 'ABORTED'
	const isRestaurant = order?.orderType === 'RESTAURANT'
	const abortReasonKey = order?.platformMetaData && REASON_CODE_TO_KEY[order?.status?.reasonCode]

	return (
		isRestaurant ?
			<OrderHeaderWrap>
				{isAbortedOrder ?
					<AbortedHeader order={order} /> :
					<OrderHeaderRestaurant>
						<OrderHeaderRestaurantInfo>
							{order?.orderDayCounter && <OrderTitle className="bold"> {t('Modal.number')}: {order?.orderDayCounter}</OrderTitle>}
							{roomNumber && <OrderSubTitle>{t('RoomCharge.room', { room: roomNumber })}</OrderSubTitle>}
						</OrderHeaderRestaurantInfo>
						{order?.firstOrderTse?.startTime &&
							<TseErstbestellung startTime={order.firstOrderTse.startTime} />}
					</OrderHeaderRestaurant>}
			</OrderHeaderWrap> :
			<OrderHeaderWrap>
				{beeperCode && <OrderPagerCode>{t('Modal.pagerCode', { beeperCode })}</OrderPagerCode>}
				<OrderCompanyTitle data-testid="customer-info" className="center">
					{isAbortedOrder ?
						<>
							<OrderAbortWrap>
								<OrderAbortTitle className="lf-uppercase">{t('Modal.orderAbortInfo.orderAborted')}</OrderAbortTitle>
							</OrderAbortWrap>
							{abortReasonKey && <div>{t(abortReasonKey)}</div>}
							{order?.platformMetaData?.platformName &&
								<div>{order?.platformMetaData?.platformName}: #{order?.platformMetaData?.refId}</div>}
						</> :
						<div>{t('Modal.invoice')}
							{order?.platformMetaData?.platformName &&
								<span> {order?.platformMetaData?.platformName}: #{order?.platformMetaData?.refId}</span>}
							{order?.kioskMetaData &&
								<span> {t('Modal.kiosk')}: #{order?.kioskMetaData?.refId}</span>}
						</div>}
					{order?.orderDayCounter && <div>{t('Modal.orderDate', getOrderTime(order?.orderDate))}
						{order?.orderDayCounter && <span> {t('Modal.number')}: {order?.orderDayCounter}</span>}
					</div>}
					{ticketOrderNumber && <div><span>{t('Modal.ticketOrderNumber')}: {ticketOrderNumber}</span></div>}
					{roomNumber && <div>{t('RoomCharge.room', { room: roomNumber })}</div>}
					{customerNumberText}
					{customerNameText}
					{phoneNumberText}
					{companyNameText}
					{addressText}
					{customerFloorText}
				</OrderCompanyTitle>
				{order?.preOrder && !isDeliveryByPlatform &&
					<OrderSubTitle className="center bold">{t('Modal.preorderDate', getOrderTime(order?.preOrder))}</OrderSubTitle>}
				{isExpressDelivery && order?.expectedDeliveryTime &&
					<OrderSubTitle className="center bold">{t('Modal.expressDate', getOrderTime(order?.expectedDeliveryTime))}</OrderSubTitle>}
				{isExpressDelivery && order?.expectedPickupTime &&
					<OrderSubTitle className="center bold">{t('Modal.expressDate', getOrderTime(order?.expectedPickupTime))}</OrderSubTitle>}
				{(order?.orderType === 'DELIVERY' && expectedDeliveryTime && !order?.preOrder) &&
					<OrderSubTitle className="center bold">{t('Modal.deliveryTime', { time: getNeededDateFormat(expectedDeliveryTime, 'H:mm') })}</OrderSubTitle>}
				{isPlatformDriverOrder && !isPartnerDriverOrder &&
					<OrderSubTitle className="center bold">
						{t('Modal.platformDriverArriveTime', { arriveTime: getNeededDateFormat(driverArriveTime, 'dd.MM | H:mm') })}
					</OrderSubTitle>}
				{order?.remark && <OrderRemark>{order?.remark}</OrderRemark>}
			</OrderHeaderWrap>
	)
})

OrderHeader.displayName = 'OrderHeader'
export default OrderHeader
